// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Ksf2","range":"MonthRangeSwitch_range__FkWld","disabled":"MonthRangeSwitch_disabled__3qt2A"};